module.exports = __webpack_public_path__ + "static/Danae-e6bfdd2b98ad24c2b9bd7738d4313994.png";